import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import Ad from '@ifeng/ui_pc_ad';
import errorBoundary from '@ifeng/errorBoundary';
import Title from './title/';
import SubTitle from './subTitle/';

class Tab extends React.PureComponent {
    static propTypes = {
        title: PropTypes.object,
        subTitle: PropTypes.object,
        ad: PropTypes.object,
        current: PropTypes.number,
        handleTabsChange: PropTypes.func,
    };

    /**
     * 渲染组件
     */
    render() {
        const { title, subTitle, ad, current, handleTabsChange } = this.props;

        return (
            <div className={styles.tab}>
                {title ? (
                    <Chip
                        id={title.id}
                        type={title.type}
                        title={title.title}
                        groupName={title.groupName}
                        content={title.content}
                        position="relative">
                        <Title current={current} handleTabsChange={handleTabsChange} />
                    </Chip>
                ) : (
                    ''
                )}
                {subTitle ? (
                    <Chip
                        id={subTitle.id}
                        type={subTitle.type}
                        title={subTitle.title}
                        groupName={subTitle.groupName}
                        content={subTitle.content}
                        position="relative">
                        <SubTitle />
                    </Chip>
                ) : (
                    ''
                )}
                {ad ? (
                    <NoSSR onSSR={<div className={styles.tg_box} />}>
                        <Ad content={ad} styleName={styles.tg_box} />
                    </NoSSR>
                ) : (
                    ''
                )}
            </div>
        );
    }
}

export default errorBoundary(Tab);
